import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch } from 'hooks/use-redux'
import { updatePlaylistBaseObj } from '@disco/state-management/actions/playlist-actions'
import RemoveWatermarkingModal from 'components/modals/remove-watermarking-modal'

const RemoveWatermarkingModalPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams<{ playlistId: string }>()
  const playlistId = params.playlistId!
  return (
    <RemoveWatermarkingModal
      onClose={() => navigate('/watermarking')}
      onSubmit={() => {
        dispatch(
          updatePlaylistBaseObj(
            parseInt(playlistId, 10),
            {
              watermark: false,
            },
            {
              success: 'Watermarking removed from playlist!',
              error: 'Error!',
            },
          ),
        )
        navigate('/watermarking')
      }}
    />
  )
}

export default RemoveWatermarkingModalPage
